import { render, staticRenderFns } from "./Experiment_4_0.vue?vue&type=template&id=60e43a3e&scoped=true&"
import script from "./Experiment_4_0.vue?vue&type=script&lang=js&"
export * from "./Experiment_4_0.vue?vue&type=script&lang=js&"
import style0 from "./Experiment_4_0.vue?vue&type=style&index=0&id=60e43a3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e43a3e",
  null
  
)

export default component.exports